import React from 'react'
import {Divider, Steps, Row, Col, Input, Select, Checkbox, DatePicker, Button, Table, Popconfirm, Modal, Tooltip, message, BackTop, Spin} from 'antd'
import common from '@/public/common'
import './list.less'
import { withRouter } from 'react-router-dom'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import { summation, getCookie, getParmUrl, outputMoney, getCookieNew } from '../../public/utils'
import moment from 'moment'
import {QuestionCircleOutlined,PrinterOutlined} from '@ant-design/icons'
const { Step } = Steps
const { Option } = Select
const {TextArea} = Input
const host = window.location.host

class ListDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      sping: false,
      visible: false,
      info: {},
      data: [],
      dataSum: { // 本期产生应付明细金额合计
        purchase_amount: 0,
        distribution_amount: 0,
        freight_amount: 0
      },
      dataPaid: [],
      dataPaidSum: { // 本期已付款明细金额合计
        purchase_payment: 0,
        distribution_payment: 0,
        advance_payment: 0
      },
      dataReceivable: [],
      dataReceivableSum: { // 本期产生应收明细金额合计
        receivable_amount: 0
      },
      dataReceipt: [],
      dataReceiptSum: { // 本期已收款明细金额合计
        amount: 0
      },
      dataStrike: [],
      dataStrikeSum: { // 本期待冲账明细金额合计
        receivable_amount: 0
      },
      dataCollect: []
    }
  }
  componentWillMount () {
    this.setState({
      sping: true
    }, () => {
      this.getDetails()
    })
  }
    // 获取对账单详情
    getDetails = () => {
      let _item = getCookieNew('supplierinfo') ? JSON.parse(getCookieNew('supplierinfo')).code : ''
      getMethod(common.SapUrl + '/reconciliation/query-detail-out/' + getParmUrl('code') + '/' + _item).then((res) => {
        if (res) {
          let _purchase_amount = summation(res.data.detail.map(item => { // 本期产生应付明细-采购金额合计
            return item.purchase_amount
          }))
          let _distribution_amount = summation(res.data.detail.map(item => { // 本期产生应付明细-铺货金额合计
            return item.distribution_amount
          }))
          let _freight_amount = summation(res.data.detail.map(item => { // 本期产生应付明细-货返金额合计
            return item.freight_amount
          }))
          let _info1 = this.state.dataSum
          _info1.purchase_amount = _purchase_amount
          _info1.distribution_amount = _distribution_amount
          _info1.freight_amount = _freight_amount
          let _purchase_payment = summation(res.data.paid.map(item => { // 本期已付款明细-采购付款/冲账合计
            return item.purchase_payment
          }))
          let _distribution_payment = summation(res.data.paid.map(item => { // 本期已付款明细-铺货付款/冲账合计
            return item.distribution_payment
          }))
          let _advance_payment = summation(res.data.paid.map(item => { // 本期已付款明细-预付款/冲账合计
            return item.advance_payment
          }))
          let _info2 = this.state.dataPaidSum
          _info2.purchase_payment = _purchase_payment
          _info2.distribution_payment = _distribution_payment
          _info2.advance_payment = _advance_payment
          let _receivable_amount = summation(res.data.receivable.map(item => { // 本期产生应收明细-应收金额合计
            return item.receivable_amount
          }))
          let _info3 = this.state.dataReceivableSum
          _info3.receivable_amount = _receivable_amount
          let _amount = summation(res.data.receipt.map(item => { // 本期已收款明细-金额合计
            return item.amount
          }))
          let _info4 = this.state.dataReceiptSum
          _info4.amount = _amount
          let _receivable_amount_wait = summation(res.data.strike_balance.map(item => { // 本期待冲账明细-应收金额合计
            return item.receivable_amount
          }))
          let _info5 = this.state.dataStrikeSum
          _info5.receivable_amount = _receivable_amount_wait
          this.setState({
            sping: false,
            dataSum: _info1,
            dataPaidSum: _info2,
            dataReceivableSum: _info3,
            dataReceiptSum: _info4,
            dataStrikeSum: _info5,
            info: res.data.item,
            data: res.data.detail,
            dataPaid: res.data.paid,
            dataReceivable: res.data.receivable,
            dataReceipt: res.data.receipt,
            dataStrike: res.data.strike_balance,
            dataCollect: res.data.collect
          })
        }
      })
    }
     // 打印弹框选择
     print = () => {
       this.setState({
         visible: true
       })
     }
    // 选择要打印的明细
    printDetails = (type) => {
      if (type === 'summary') {
        window.open('http://' + host + '/main/supplierRecantion/summaryPrint?code=' + getParmUrl('code')+"&poSubjectName="+getParmUrl("poSubjectName"))
      } else {
        window.open('http://' + host + '/main/supplierRecantion/detailsPrint?code=' + getParmUrl('code')+"&poSubjectName="+getParmUrl("poSubjectName"))
      }
    }
    handelCancel = () => {
      this.setState({
        visible: false
      })
    }
    // 导出
    export = (name) => {
      if (name === 'all') {
        fileDownloadApiNew({
          url: common.SapUrl + '/reconciliation/export-collect/' + getParmUrl('code')+"/"+getParmUrl("poSubjectName"),
          param: {},
          filename: '汇总-' + this.state.info.supplier_name + this.state.info.reconciliation_code + '.xlsx'
        })
      } else {
        fileDownloadApiNew({
          url: common.SapUrl + '/reconciliation/export-detail/' + getParmUrl('code')+"/"+getParmUrl("poSubjectName"),
          param: {},
          filename: '明细-' + this.state.info.supplier_name + this.state.info.reconciliation_code + '.xlsx'
        })
      }
    }
    render () {
      const { visible, info, data, dataSum, dataPaid, dataPaidSum, dataReceivable, dataReceivableSum, dataReceipt, dataReceiptSum, dataStrike, dataStrikeSum, dataCollect } = this.state
      const detailsColums = [
        {
          title: '发生日期',
          align: 'center',
          width: 150,
          dataIndex: 'happen_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '入（出）库单号',
          align: 'center',
          width: 180,
          dataIndex: 'stock_in_code'
        },
        {
          title: '采购（退）单号',
          align: 'center',
          width: 180,
          dataIndex: 'purchase_code'
        },
        {
          title: '供应商发货单号',
          align: 'center',
          width: 180,
          dataIndex: 'deliver_code'
        },
        {
          title: '采购类型',
          align: 'center',
          width: 120,
          dataIndex: 'type'
        },
        {
          title: '预计付款时间',
          align: 'center',
          width: 150,
          dataIndex: 'later_payable_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '采购金额',
          align: 'center',
          width: 150,
          align: 'right',
          dataIndex: 'purchase_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '铺货金额',
          align: 'center',
          width: 150,
          align: 'right',
          dataIndex: 'distribution_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '货返金额',
          align: 'center',
          width: 150,
          align: 'right',
          dataIndex: 'freight_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        }
      ]
      const writeColums = [
        {
          title: '发生时间',
          width: 180,
          align: 'center',
          dataIndex: 'happen_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '付款单号',
          width: 180,
          align: 'center',
          dataIndex: 'payment_code'
        },
        {
          title: '付款方式',
          width: 180,
          align: 'center',
          dataIndex: 'payment_type'
        },
        {
          title: '采购付款/冲账',
          width: 180,
          align: 'right',
          dataIndex: 'purchase_payment',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '铺货付款/冲账',
          width: 180,
          align: 'right',
          dataIndex: 'distribution_payment',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '预付款/冲账',
          width: 180,
          align: 'right',
          dataIndex: 'advance_payment',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        }
      ]
      const backColums = [
        {
          title: '返利产生时间',
          width: 150,
          align: 'center',
          dataIndex: 'rebate_happen_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM') : ''}</span>
          )
        },
        {
          title: '返利类型',
          width: 120,
          align: 'center',
          dataIndex: 'rebate_type'
        },
        {
          title: '返利政策',
          width: 200,
          align: 'center',
          dataIndex: 'rebate_strategy',
          render: (text, record) => (
            // <a onClick={this.goFlzc.bind(this, record)}>{text}</a>
            <span>{text}</span>
          )
        },
        {
          title: '预计收回时间',
          width: 150,
          align: 'center',
          dataIndex: 'recovery_time',
          render: (text) => (
            <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '应收金额',
          width: 150,
          align: 'right',
          dataIndex: 'receivable_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        }
      ]
      const getColums = [
        {
          title: '发生时间',
          width: 160,
          align: 'center',
          dataIndex: 'happen_time',
          render: (text) => (
            <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '收款单号',
          width: 180,
          align: 'center',
          dataIndex: 'receipt_code'
        },
        {
          title: '收款方式',
          width: 180,
          align: 'center',
          dataIndex: 'receipt_type'
        },
        {
          title: '收款（冲账）金额',
          width: 140,
          align: 'right',
          dataIndex: 'amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '返利政策',
          width: 220,
          align: 'center',
          dataIndex: 'rebate_strategy',
          render: (text, record) => (
            // <a onClick={this.goFlzc.bind(this, record)}>{text}</a>
            <span>{text}</span>
          )
        },
        {
          title: '备注',
          width: 180,
          align: 'center',
          dataIndex: 'remark'
        }
      ]
      const waitColums = [
        {
          title: '预计收回时间',
          width: 150,
          align: 'center',
          dataIndex: 'recovery_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '返利类型',
          width: 120,
          align: 'center',
          dataIndex: 'rebate_type'
        },
        {
          title: '返利政策',
          width: 200,
          align: 'center',
          dataIndex: 'rebate_strategy',
          render: (text, record) => (
            // <a onClick={this.goFlzc.bind(this, record)}>{text}</a>
            <span>{text}</span>
          )
        },
        {
          title: '返利产生时间',
          width: 150,
          align: 'center',
          dataIndex: 'rebate_happen_time',
          render: (text) => (
            <span>{ text ? moment(text).format('YYYY-MM') : ''}</span>
          )
        },
        {
          title: '应收金额',
          width: 150,
          align: 'right',
          dataIndex: 'receivable_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        }
      ]
      const sumColums = [
        {
          title: '项目',
          align: 'center',
          dataIndex: 'project'
        },
        {
          title: '期初',
          align: 'right',
          dataIndex: 'begin_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: () => (
            <div>
              <span>本期增加</span>
              <Tooltip title="当前账期产生的应付流水/返利应收流水总额"><QuestionCircleOutlined style={{fontSize: '14px', marginLeft: '4px'}} /></Tooltip>
            </div>
          ),
          align: 'right',
          dataIndex: 'add_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: () => (
            <div>
              <span>本期减少</span>
              <Tooltip title="当前账期已支付/已回收/已冲账的金额汇总"><QuestionCircleOutlined style={{fontSize: '14px', marginLeft: '4px'}} /></Tooltip>
            </div>
          ),
          align: 'right',
          dataIndex: 'reduce_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: '期末',
          align: 'right',
          dataIndex: 'end_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        },
        {
          title: () => (
            <div>
              <span>预计冲账</span>
              <Tooltip title="下个账期即将进行冲销的金额汇总"><QuestionCircleOutlined style={{fontSize: '14px', marginLeft: '4px'}} /></Tooltip>
            </div>
          ),
          align: 'right',
          dataIndex: 'reconciliation_amount',
          render: (text) => (
            <span>{outputMoney(text)}</span>
          )
        }
      ]
      const expandedRowRender = (record) => {
        const columns = [
          {
            title: '',
            dataIndex: 'new',
            width: 10
          },
          {
            title: '商品编码',
            dataIndex: 'item_code'
          },
          {
            title: '商品名称',
            dataIndex: 'item_name'
          },
          {
            title: '入库数量',
            dataIndex: 'qty'
          },
          {
            title: '仓库',
            dataIndex: 'whid_name'
          },
          {
            title: '单价',
            align: 'right',
            dataIndex: 'price',
            render: (text) => (
              <span>{text ? text.toFixed(5):'--'}</span>
            )
          },
          {
            title: '金额',
            align: 'right',
            dataIndex: 'amount',
            render: (text, record1) => (
              <span>{record1.qty < 0 && record.type === '采购退货' ? '-' : ''}{outputMoney(text)}</span>
            )
          }
        ]
        return <Table columns={columns} dataSource={record.items} pagination={false}/>
      }
      const footerDetials = () => {
        return <div>
          <span style={{display: 'inline-block', width: '10%', marginLeft: '60%', textAlign: 'center'}}>本期合计：</span>
          <span style={{display: 'inline-block', width: '10%', textAlign: 'right', paddingRight: '1%'}}>{outputMoney(dataSum.purchase_amount)}</span>
          <span style={{display: 'inline-block', width: '10%', textAlign: 'right', paddingRight: '1%'}}>{outputMoney(dataSum.distribution_amount)}</span>
          <span style={{display: 'inline-block', width: '10%', textAlign: 'right', paddingRight: '1%'}}>{outputMoney(dataSum.freight_amount)}</span>
        </div>
      }
      const footerWrite = () => {
        return <div>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'center', marginLeft: '32%'}}>本期合计：</span>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'right'}}>{outputMoney(dataPaidSum.purchase_payment)}</span>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'right'}}>{outputMoney(dataPaidSum.distribution_payment)}</span>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'right'}}>{outputMoney(dataPaidSum.advance_payment)}</span>
        </div>
      }
      const footerBack = () => {
        return <div>
          <span style={{display: 'inline-block', textAlign: 'center', width: '15%', marginLeft: '70%'}}>本期合计：</span>
          <span style={{display: 'inline-block', textAlign: 'right', width: '14%'}}>{outputMoney(dataReceivableSum.receivable_amount)}</span>
        </div>
      }
      const footerGet = () => {
        return <div>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'center', marginLeft: '27%'}}>本期合计：</span>
          <span style={{display: 'inline-block', width: '17%', textAlign: 'right'}}>{outputMoney(dataReceiptSum.amount)}</span>
        </div>
      }
      const footerWait = () => {
        return <div>
          <span style={{display: 'inline-block', textAlign: 'center', width: '15%', marginLeft: '70%'}}>本期合计：</span>
          <span style={{display: 'inline-block', textAlign: 'right', width: '14%'}}>{outputMoney(dataStrikeSum.receivable_amount)}</span>
        </div>
      }
      return (
        <div className="listDetails">
          <Spin spinning={this.state.sping}>
            <div className="head">
              <div className="title">
                {/* <div className="logo"></div> */}
                <h1>{getParmUrl('poSubjectName')}  对账单</h1>
                <div className='newButton'>
                  <span style={{marginRight: '15px'}}><Button shape="round" type="primary" onClick={this.export.bind(this, 'all')}>汇总导出</Button></span>
                  <span style={{marginRight: '15px'}}><Button shape="round" type="primary" onClick={this.export.bind(this, 'details')}>明细导出</Button></span>
                  <span><Button shape="round" onClick={this.print}>打印</Button></span>
                </div>
              </div>
              <div className="titleDesc">
                <Row style={{marginBottom: '15px'}}>
                  <Col span={10}>
                    <label style={{width: '30%', textAlign: 'right'}}>账单号：</label>
                    <span>{info.reconciliation_code}</span>
                  </Col>
                  <Col span={10}>
                    <label style={{width: '30%', textAlign: 'right'}}>对账日期：</label>
                    <span>{info.reconciliation_begin_time ? moment(info.reconciliation_begin_time).format('YYYY-MM-DD') + '~' + moment(info.reconciliation_end_time).format('YYYY-MM-DD') : ''}</span>
                  </Col>
                </Row>
                <Row style={{marginBottom: '15px'}}>
                  <Col span={10}>
                    <label>供应商代码：</label>
                    <span>{info.supplier_code}</span>
                  </Col>
                  <Col span={10}>
                    <label>供应商名称：</label>
                    <span>{info.supplier_name}</span>
                  </Col>
                </Row>
                <Row style={{marginBottom: '15px'}}>
                  <Col span={10}>
                    <label>出账人：</label>
                    <span>{info.check}</span>
                  </Col>
                  <Col span={10}>
                    <label>出账时间：</label>
                    <span>{info.charge_off_time ? moment(info.charge_off_time).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                  </Col>
                </Row>
                <Row style={{marginBottom: '15px'}}>
                  <Col span={10}>
                    <label>备注：</label>
                    <span>{info.remark}</span>
                  </Col>
                  {/* <Col span={12} style={{textAlign: 'right'}}>
                                <span style={{marginRight: '15px'}}><Button type="primary" onClick={this.export.bind(this, 'all')}>汇总导出</Button></span>
                                <span style={{marginRight: '15px'}}><Button type="primary" onClick={this.export.bind(this, 'details')}>明细导出</Button></span>
                                <span><Button onClick={this.print}>打印</Button></span>
                            </Col> */}
                </Row>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">本期产生应付明细</p>
              <div className="detailsContent">
                <Table columns={detailsColums} dataSource={data} expandedRowRender={(record) => expandedRowRender(record)} pagination={false} footer={footerDetials}/>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">本期已付款明细（含冲账）</p>
              <div className="detailsContent">
                <Table columns={writeColums} dataSource={dataPaid} footer={footerWrite} pagination={false}/>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">本期产生应收明细（返利+品牌补贴）</p>
              <div className="detailsContent">
                <Table columns={backColums} dataSource={dataReceivable} footer={footerBack} pagination={false}/>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">本期已收款明细（含冲账）</p>
              <div className="detailsContent">
                <Table columns={getColums} dataSource={dataReceipt} footer={footerGet} pagination={false}/>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">本期待冲账明细</p>
              <div className="detailsContent">
                <Table columns={waitColums} dataSource={dataStrike} footer={footerWait} pagination={false}/>
              </div>
            </div>
            <div className="payDetails">
              <p className="detailsName">累计汇总</p>
              <div className="detailsContent">
                <Table columns={sumColums} dataSource={dataCollect} pagination={false} rowKey={index => index}/>
              </div>
            </div>
            {/* <div className="goback">
                    <Button type="primary">返回</Button>
                </div> */}

            <Modal title="选择打印方式"
              className="printModal"
              visible={visible}
              onCancel={this.handelCancel}
              footer={[]}>
              <a onClick={this.printDetails.bind(this, 'summary')}><PrinterOutlined style={{marginRight: '4px'}}/>汇总打印</a>
              <a onClick={this.printDetails.bind(this, 'details')}><PrinterOutlined style={{marginRight: '4px'}}/>明细打印</a>
            </Modal>
            <BackTop visibilityHeight={40}/>
          </Spin>
        </div>
      )
    }
}
export default ListDetail



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/listDetails.js